/* eslint-disable @next/next/no-img-element */
import axios from "axios";
import Link from "next/link";
import { useEffect, useState } from "react";

function Thumbnail(props) {
    return (
        <div
            onClick={props.onClick}
            className={
                "border-2 rounded-md m-1 overflow-hidden hover:bg-white dark:hover:bg-gray-900 cursor-pointer  " +
                (props.selected ? "  dark:border-secondary-dark border-secondary" : "border-gray-50 dark:border-gray-900")
            }
        >
            <img
                width={52}
                height={52}
                alt=""
                src={props.fallback ? `https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/${props.image}` : `https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/${props.image}/sm`}
            />
        </div>
    );
}

export default function CreateHistory(props) {
    const [images, setImages] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        setSelected(null);
        setImages([]);
        axios.post(`/api/image/history?limit=${props.isMinimal ? 3 : 9}`).then((result) => {
            setImages(result.data?.history);
            if (props.latest) {
                setSelected(result.data?.history[0]?.svg);
            }
        });
    }, [props.latest]);

    return (
        <div>
            <div className="text-xs mb-1 font-medium px-1 dark:text-gray-400">
                {images && images.length > 0 ? <Link href="/my">My creations</Link> : null}
            </div>
            <div className={"flex flex-wrap " + (props.className || "")}>
                {images?.map((image, i) => (
                    <Thumbnail
                        selected={selected === image.svg}
                        key={image.svg}
                        image={image.svg}
                        fallback={image.fallback}
                        onClick={() => {
                            setSelected(image.svg);
                            props.onSelect?.(image);
                            window.umami?.track("Create History - Select", {
                                image: image.svg,
                            });
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
